export enum TrackEvents {
  PROPOSAL_REQUESTED = 'creditProposalStart',
  PROPOSAL_CONFIRMED = 'loanProposalConfirmed',
  PROPOSAL_PASSWORD_WRONG = 'confirmIncorrectPassword',
  PROPOSAL_ACCEPTED = 'loanSuccess',
}
